/**
 * Surface — glass/depth card primitive.
 *
 * Visual language: frosted-glass fintech. Translucent white fill backed by
 * backdrop-blur, soft long shadow, thin inner highlight border. On the
 * shell's tinted gradient background, each card reads as floating.
 *
 * For clickable surfaces, pass `interactive` for a hover lift.
 */

import type { ReactNode } from 'react';

export interface SurfaceProps {
  children: ReactNode;
  interactive?: boolean;
  className?: string;
}

const BASE =
  'rounded-2xl bg-white/60 backdrop-blur-xl border border-white/60 shadow-lg shadow-slate-900/5 p-5';

const HOVER =
  ' transition duration-200 hover:-translate-y-0.5 hover:bg-white/75 hover:shadow-xl hover:shadow-slate-900/10';

export function Surface({ children, interactive = false, className = '' }: SurfaceProps) {
  return <div className={`${BASE}${interactive ? HOVER : ''} ${className}`}>{children}</div>;
}
